import PageWrapper from '#/components/PageWrapper/PageWrapper';
import { useAppRoute } from '@streamster/shared/navigation/navigation.ref';
import { AddNewCouponCode } from '#/screens/adminCouponCodes/AddNewCouponCode/AddNewCouponCode';
import { CouponCodeList } from '#/screens/adminCouponCodes/CoponCodeList/CouponCodeList';
import { EditCoupon } from '#/screens/adminCouponCodes/EditCoupon/EditCoupon';

export const AdminCouponCodesScreen: React.FC = () => {
  const { params } = useAppRoute<'AdminCouponCodes'>();

  return (
    <PageWrapper>
      {params?.view === 'create' && <AddNewCouponCode />}
      {params?.view === 'edit' && <EditCoupon />}
      {(!params?.view || params.view === 'list') && <CouponCodeList />}
    </PageWrapper>
  );
};
